"use strict";

// Used by both the React tour page and the Node prerender script.
// Keep the original matching rule: same tour type, location OR category.
function normalizedTokens(value) {
  if (Array.isArray(value)) {
    return value.map((v) => String(v ?? "").trim().toLowerCase()).filter(Boolean);
  }
  if (typeof value !== "string") return [];
  const raw = value.trim();
  if (!raw) return [];
  if (raw.startsWith("[")) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return normalizedTokens(parsed);
    } catch (_) {
      return [];
    }
  }
  return raw.split(",").map((v) => v.trim().toLowerCase()).filter(Boolean);
}

function overlaps(a, b) {
  if (!a.length || !b.length) return false;
  const lookup = new Set(b);
  return a.some((value) => lookup.has(value));
}

function getRelatedTours(tour, allTours, limit = 4) {
  if (!tour || !Array.isArray(allTours)) return [];
  const currentType = String(tour.tour_type || "").trim().toLowerCase();
  const currentLocations = normalizedTokens(tour.locations);
  const currentCategories = normalizedTokens(tour.categories);
  const max = Math.max(0, Math.min(12, Number(limit) || 0));
  const seen = new Set();

  return allTours.filter((candidate) => {
    if (!candidate || !candidate.slug || candidate.id === tour.id || candidate.slug === tour.slug) {
      return false;
    }
    // Avoid duplicate or unsafe route slugs in generated HTML.
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(candidate.slug) || seen.has(candidate.slug)) {
      return false;
    }
    const typeMatch = Boolean(currentType) &&
      String(candidate.tour_type || "").trim().toLowerCase() === currentType;
    const locationMatch = overlaps(normalizedTokens(candidate.locations), currentLocations);
    const categoryMatch = overlaps(normalizedTokens(candidate.categories), currentCategories);
    if (!(typeMatch || locationMatch || categoryMatch)) return false;
    seen.add(candidate.slug);
    return true;
  }).slice(0, max);
}

module.exports = { getRelatedTours };
